import React, { useState } from 'react'
import '../assets/css/PlayerSubScreen.css'
import HeaderLogo from '../assets/images/PlayerScreen/HeaderLogo.svg'
import sampleImg1 from '../assets/images/PlayerScreen/myPic.jpg'
import sampleImg2 from '../assets/images/PlayerScreen/myPic1.png'
import pak from '../assets/images/PlayerScreen/pak.png'
import dia from '../assets/images/PlayerScreen/dia.png'
import crown from '../assets/images/PlayerScreen/crown.svg'
import PlayerLeftIcon from '../assets/images/PlayerScreen/PlayerLeftIcon.svg'
import PlayerRightIcon from '../assets/images/PlayerScreen/PlayerRightIcon.svg'
import Header from './Header'
import Footer from '../components/Footer'
import { useNavigate } from "react-router-dom";
import '../assets/css/style.scss'


const PlayerSubScreen = () => {



  const [data, setData] = useState([
    {
      id: 0,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 1,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 2,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 3,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 4,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 5,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 6,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 7,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 8,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 9,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 10,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 11,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 12,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 13,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 14,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 15,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 16,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 17,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 18,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 19,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 20,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 21,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 22,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 23,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 24,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 25,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 26,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 27,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 28,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 29,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 30,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 31,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 32,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 33,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 34,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 35,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 36,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 37,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 38,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 39,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 40,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 41,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 42,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 43,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 44,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 45,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 46,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 47,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 48,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 49,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 50,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 51,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 52,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 53,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 54,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 55,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 56,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 57,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 58,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 59,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 60,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 61,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 62,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 63,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 64,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 65,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 66,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 67,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 68,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 69,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 70,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 71,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 72,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 73,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 74,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 75,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 76,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 77,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 78,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 79,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 80,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 81,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 82,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 83,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 84,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 85,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 86,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 87,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 88,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 89,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 90,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },
    {
      id: 91,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 92,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 93,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg2,
      pic1: pak,
      pic2: dia,
      select: false
    },

    {
      id: 94,
      text1: "Hafiz F",
      text2: "Hafiz F1",
      pic: sampleImg1,
      pic1: pak,
      pic2: dia,
      select: false
    },
  ]);



  const [playerScreenData, setPlayerScreenData] = useState([])
  const [playerScreenDataColor, setPlayerScreenDataColor] = useState(false)
  const navigate = useNavigate();
  const addTop = (addId) => {

    setPlayerScreenDataColor({ ...playerScreenDataColor, [addId]: !playerScreenDataColor[addId] })

    console.log("first", addId)

    if (playerScreenData.length === 7) {
console.log("8 selected")
navigate("/playerwaiting");
    }

    if (playerScreenData.length < 8) {


      const newObj = data.filter((item) => {
        const { id, pic, pic1, select } = item
        return (
          id === addId && select === false
        )
      })


      console.log(newObj)
      if (newObj.length > 0) {
        setPlayerScreenData(prev => [...prev, newObj[0]])


        setData(prevState => {
          const newState = prevState.map(obj => {
            if (obj.id === addId) {
              return { ...obj, select: true };
            }

            return obj;
          });

          return newState;
        });
      }

      console.log("Player Screen", playerScreenData)
    }
  }

  return (
    <>

      <div className="fluid-container" style={{height:"100vh"}}>

        <Header />

        <div className='player-screen-body' style={{height:"100%"}}>
          <div className="row  mx-3 mb-2">

            <div className="col-12 my-0 d-flex justify-content-center align-items-center">

              <p className='mt-2 py-2  px-4 mb-0 ' style={{border:"1px solid #D6A15E", boxShadow:" 0px 12px 24px -12px rgba(0, 0, 0, 0.5)", borderRadius:"84px", background:"rgba(0, 0, 0, 0.3)"}}> <img style={{width:"1.7vw", marginBottom:"3%"}} src={PlayerLeftIcon} alt="" /> <span className='px-1' style={{fontSize:"1.4vw", fontWeight:"700", color:"#D6A15E", letterSpacing:"1px"}}> Select Player </span> <img style={{width:"1.7vw", marginBottom:"3%"}} src={PlayerRightIcon} alt="" /> </p>

            </div>

            {/* <div className="col-12"></div> */}

           <div className="col-12 px-4">


<div className="row px-4">

{playerScreenData &&
              playerScreenData.map((el) => {
                return (

                  <div className="col-lg-3 col-md-3 col-4 mb-2 mt-2 px-1" >

<div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-2' src={el.pic} alt="" />

                        <div className='position-absolute player-screen-card-crown-upper'>
                          <img src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='player-screen-card-div1-upper'>

                          <img src={el.pic1} alt="" /> <span className='player-screen-card-text1-upper text-light'>{el.text1}</span>

                        </div>

                        <div className='player-screen-card-div2-upper'>

                          <img src={el.pic2} alt="" />  <span className='player-screen-card-text2-upper text-light'>{el.text2}</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>

                );
              })}

</div>

           </div>
           
            <div className="col-12 "><hr className='player-screen-body-text-line mt-2 mb-2 ' /></div>

            <div className="col-12" style={{height:"100vh"}}>

              <div className="row mx-2 scroller">

                {data &&
                  data.map((el) => {
                    return (

                      <div className="col-lg-2 col-md-3 col-4 mb-2 mt-2 px-1" >

                        <div className={playerScreenDataColor[el.id] ? "player-screen-body-border-color " : "player-screen-body-border "} onClick={() => addTop(el.id)}>


                          <div className="row ">

                            <div className="col-3 position-relative ">
                              <img className='player-screen-card-profile m-2' src={el.pic} alt="" />

                              <div className='position-absolute player-screen-card-crown'>
                                <img src={crown} alt="" />
                              </div>

                            </div>

                            <div className="col-9">

                              <div className='player-screen-card-div1'>

                                <img src={el.pic1} alt="" /> <span className='player-screen-card-text1 text-light'>{el.text1}</span>

                              </div>

                              <div className='player-screen-card-div2'>

                                <img src={el.pic2} alt="" />  <span className='player-screen-card-text2 text-light'>{el.text2}</span>

                              </div>


                            </div>

                          </div>

                        </div>

                      </div>


                    );
                  })}

              </div>

            </div>

          </div>
          {/* <div className="col-12 "><hr className='player-screen-body-text-line mt-4 mx-3 ' /></div> */}

          <div className='col-12' style={{position:"fixed", bottom:"0", backgroundColor:"black"}}>

          <Footer BackPage="/today-prize" NextPage={"/playerwaiting"}/>

          </div>

        </div>

      </div>

    </>
  )
}

export default PlayerSubScreen